import Staffs from "./components/Staffs";

export default Staffs;
